var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 10,
    viewBox: "0 0 19 10",
    fill: "#666666",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.876577 0.366117C1.37868 -0.122039 2.19275 -0.122039 2.69485 0.366117L9.5 6.98223L16.3051 0.366117C16.8073 -0.122039 17.6213 -0.122039 18.1234 0.366117C18.6255 0.854272 18.6255 1.64573 18.1234 2.13388L10.4091 9.63388C9.90703 10.122 9.09297 10.122 8.59086 9.63388L0.876577 2.13388C0.374474 1.64573 0.374474 0.854272 0.876577 0.366117Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.c9a7bf391881f658c3597bed15fc4971.svg";
export { ForwardRef as ReactComponent };